import { Injectable } from '@angular/core';
import { PingResult } from '../../models/app/ping-result';
import { BaseStore } from './base.store';

@Injectable({
  providedIn: 'root',
})
export class PingStore extends BaseStore<PingResult> {}
